import styled from 'styled-components'

export default styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  font-size: 1.4rem;

  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1270px) {
    max-width: 1240px;
  }

  .purchase-success {
    p {
      margin: 0;
      font-size: 1.8rem;
      font-weight: bold;
    }
  }

  .thank-you {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 5rem 0 3rem 0;
    text-align: center;

    .thanks {
      font-size: 3.2rem;
      color: ${(props) => props.theme.palette.primary};
      font-weight: bold;
    }

    .soon {
      font-size: 1.8rem;
      margin-top: 2rem;
    }
  }

  .contacts {
    width: 100%;
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 1.6rem;

    p {
      padding: 0 1rem;
    }
  }

  .details {
    .title {
      font-size: 1.8rem;
      margin-bottom: 1rem;
    }

    .description {
      text-align: center;
      font-size: 1.8rem;
      font-weight: bold;
    }

    .description-hour {
      text-align: center;
      font-size: 1.8rem;
      font-weight: bold;
      max-width: 60rem;
    }

    .description_price {
      text-align: center;
      font-size: 2.4rem;
      font-weight: bold;
      margin-top: 0.5rem;
    }
  }
`
